import React from 'react';
import { Platform } from 'react-native';

import Highlighter from '@components/HighlightWords';
import { Box, Text } from '@components/Restyle';
import theme from '@themes/theme';

interface SearchTextProps {
  searchWords: string[];
  textToHighlight: string;
}

export const ChatSearchText: React.FC<SearchTextProps> = ({
  searchWords,
  textToHighlight,
}) => {
  return (
    <Box alignItems='center' style={{ marginTop: 6, height: 24 }}>
      <Text
        px='m'
        variant='metadata'
        color='grey04'
        ellipsizeMode='tail'
        flexShrink={1}
        numberOfLines={1}
        style={Platform.OS === 'web' && { maxWidth: 470 }}>
        <Highlighter
          highlightStyle={{
            fontFamily: 'Inter_600SemiBold',
            backgroundColor: 'white',
            color: theme.colors.grey04,
          }}
          searchWords={searchWords}
          autoEscape
          textToHighlight={textToHighlight}
        />
      </Text>
    </Box>
  );
};
